/** Escape overflow/zoom clipping in sticky scratchpad chrome and transport bars. */
export const SCRATCHPAD_DROPDOWN_POPPER = { strategy: 'fixed' }
